import StopTimesCell from './container';

export default StopTimesCell;
